import { createPrefixedActions } from '@zapier/toolbox-redux-framework';

export default createPrefixedActions(
  'homepage',
  `
    CHANGE_APP_SEARCH_QUERY

    SELECT_SERVICE_SEARCH_SERVICE
  `
);
